<template>
    <div :class="['balance-box', $i18n.locale]">
        <div class="over-box" v-if="false">
            <!-- <van-loading type="spinner" /> -->
        </div>
        <div class="compare-report">
            <div class="compare-title">{{ $t("balanceReport.selectionRport") }}</div>
            <!-- 日期选择 -->
            <div class="data-time">
                <date-select :type="5" :isCreateTime="isCreateTime" @girthContras="onGetBalance"></date-select>
            </div>
        </div>
        <div class="eclairs-v">
            <div class="eclairs-v-tittle" :style="{ color: selectColor() }">
                {{ score }}
                <span>{{ $t("balanceReport.scoreUnit") }}</span>
            </div>
            <!-- 对比上次 -->
            <div class="last-style" v-if="balanceData.lastData">
                {{ $t("balanceReport.compareLast") }}
                <img
                    v-if="balanceData.totalScoreComparison > 0"
                    src="@/assets/images/icon_rise.png"
                    alt
                />
                <img v-else-if="balanceData.totalScoreComparison < 0" src="@/assets/images/icon_decline.png" alt />
                <img v-else src="@/assets/images/icon_just.png" />
                <span
                    :style="{ color: selectColorComparison(balanceData.totalScoreComparison) }"
                >{{ Math.abs(balanceData.totalScoreComparison)}}</span>
            </div>
            <p v-if="score>=0" class="eclairs-v-score" :style="{ color: selectColor() }">
                <img :src="levelStatus" alt />
                {{ status }}
            </p>
            <p v-else class="eclairs-v-score">--</p>
            <div class="eclairs-v-des">
                <div class="eclairs-v-des-title">
                    <div>
                        <!-- 感官系统评价 -->
                        <p>{{ $t("balanceReport.systemEvaluation") }}</p>
                        <span :style="sensesStatus(balanceData.currentData.eyeCloseLevel)">
                            {{
                            levelDesc[balanceData.currentData.eyeCloseLevel - 1]
                            }}
                        </span>
                    </div>
                    <div>
                        <!-- 视觉感官评价 -->
                        <p>{{ $t("balanceReport.visualEvaluation") }}</p>
                        <span :style="sensesStatus(balanceData.currentData.eyeOpenLevel)">
                            {{
                            levelDesc[balanceData.currentData.eyeOpenLevel - 1]
                            }}
                        </span>
                    </div>
                </div>
                <div class="eclairs-v-des-bottom">
                    <img class="help-icon" src="../../assets/images/report/help.png" alt />
                    {{
                    $t("balanceReport.pingDes")
                    }}
                </div>
            </div>
            <!-- 图标 -->
            <div class="eclairs-line">
                <p class="eclairs-line-sway">{{ $t("balanceReport.swayRms") }}</p>
                <div class="main-balance-box">
                    <div id="main-balance" style="width: 366px; height: 175px"></div>
                    <li class="balance-li-1">{{ unit === "metric" ? "cm" : "in." }}</li>
                    <li class="balance-li-2">{{ this.$t("balanceReport.chart.yAxisLabels[2]") }}</li>
                    <li class="balance-li-3">{{ this.$t("balanceReport.chart.yAxisLabels[1]") }}</li>
                    <li class="balance-li-4">{{ this.$t("balanceReport.chart.yAxisLabels[0]") }}</li>
                    <span class="main-balance-s1">{{ toDecimalIn(limit[0], 1) }}</span>
                    <span class="main-balance-s2">{{ toDecimalIn(limit[1], 1) }}</span>
                </div>
                <div class="main-balance-box1">
                    <div id="main-balance-open" style="width: 366px; height: 175px"></div>
                    <li class="balance-li-1">{{ unit === "metric" ? "cm" : "in." }}</li>
                    <li class="balance-li-2">{{ this.$t("balanceReport.chart.yAxisLabels[2]") }}</li>
                    <li class="balance-li-3">{{ this.$t("balanceReport.chart.yAxisLabels[1]") }}</li>
                    <li class="balance-li-4">{{ this.$t("balanceReport.chart.yAxisLabels[0]") }}</li>
                    <span class="main-balance-s3">{{ toDecimalIn(limit[2], 1) }}</span>
                    <span class="main-balance-s4">{{ toDecimalIn(limit[3], 1) }}</span>
                </div>
            </div>
        </div>
        <!-- 测量项目明细 -->
        <div class="measure-obvious">{{ $t("balanceReport.measureDes") }}</div>
        <div class="measure-obvious-points">
            <p class="measure-obvious-points-p">{{ $t("balanceReport.eyeCloseTest") }}</p>
            <div>
                <div class="eye-close-box">
                    <p
                        class="eye-close-title"
                        :style="sensesStatus(balanceData.currentData.eyeCloseLevel)"
                    >{{ selectLevelStatus(balanceData.currentData.eyeCloseLevel) }}</p>
                    <!-- v-if="balanceData.lastData" -->
                    <p v-if="balanceData.lastData" class="eye-close-title1">
                        <img
                            v-if="
                balanceData.currentData.eyeCloseLevel < balanceData.lastData.eyeCloseLevel
              "
                            src="@/assets/images/icon1_rise.png"
                            alt
                        />
                        <img
                            v-else-if="
                balanceData.currentData.eyeCloseLevel > balanceData.lastData.eyeCloseLevel
              "
                            src="@/assets/images/icon1_decline.png"
                            alt
                        />
                        <img v-else src="@/assets/images/icon1_just.png" alt />
                        {{ this.$t('balanceReport.last') }}：
                        {{ selectLevelStatus(balanceData.lastData.eyeCloseLevel) }}
                    </p>
                </div>
                <div class="eye-close-points">
                    <div class="eye-close-points-div">
                        <span>{{ $t("waist.qian") }}</span>
                        <span>{{ $t("mass.segment.left") }}</span>
                        <span>{{ $t("mass.segment.right") }}</span>
                        <span>{{ $t("waist.hou") }}</span>
                        <div class="circle">
                            <!-- 动态生成随机点 -->
                            <div v-for="(point, index) in pointsClose" :key="index" class="dot" :style="point.style"></div>
                        </div>
                        <p>{{ $t("balanceReport.centerTrajectory") }}</p>
                    </div>
                    <!-- <div class="eye-close-points-div">
            <p class="eye-close-points-div-h">{{ $t("balanceReport.copArea") }}</p>
            <p class="eye-close-points-div-h1">
              {{
                unit === "metric"
                  ? toDecimal(eyeCloseObj.area * 645.16, 2)
                  : toDecimal(eyeCloseObj.area, 2)
              }}{{ unit === "imperial" ? "in²" : "mm²" }}
            </p>
            <p class="eye-close-points-div-h">{{ $t("balanceReport.avgSpeed") }}</p>
            <p class="eye-close-points-div-h1">
              {{
                unit === "metric"
                  ? toDecimal(eyeCloseObj.speed * 25.4, 2)
                  : toDecimal(eyeCloseObj.speed, 2)
              }}{{ unit === "imperial" ? "in/s" : "mm/s" }}
            </p>
            <p class="eye-close-points-div-h">
              {{ $t("balanceReport.maxDisplacement") }}
            </p>
            <p class="eye-close-points-div-h1">
              {{
                unit === "metric"
                  ? toDecimal(eyeCloseObj.distance * 25.4, 2)
                  : toDecimal(eyeCloseObj.distance, 2)
              }}{{ unit === "imperial" ? "in" : "mm" }}
            </p>
                    </div>-->
                </div>
                <div class="close-table">
                    <table>
                        <thead>
                            <tr>
                                <th>{{ $t("balanceReport.copArea") }}</th>
                                <th>{{ $t("balanceReport.avgSpeed") }}</th>
                                <th>{{ $t("balanceReport.maxDisplacement") }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    {{
                                    unit === "metric"
                                    ? toDecimal(eyeCloseObj.area * 645.16, 2)
                                    : toDecimal(eyeCloseObj.area, 2)
                                    }}{{ unit === "imperial" ? "in²" : "mm²" }}
                                </td>
                                <td>
                                    {{
                                    unit === "metric"
                                    ? toDecimal(eyeCloseObj.speed * 25.4, 2)
                                    : toDecimal(eyeCloseObj.speed, 2)
                                    }}{{ unit === "imperial" ? "in/s" : "mm/s" }}
                                </td>
                                <td>
                                    {{
                                    unit === "metric"
                                    ? toDecimal(eyeCloseObj.distance * 25.4, 2)
                                    : toDecimal(eyeCloseObj.distance, 2)
                                    }}{{ unit === "imperial" ? "in" : "mm" }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="eye-close-points-des">{{ conclusion(balanceData.currentData.eyeCloseLevel) }}</div>
            </div>
            <div class="measure-obvious-points-br"></div>
            <p class="measure-obvious-points-pp">{{ $t("balanceReport.eyeOpenTest") }}</p>
            <div>
                <div class="eye-close-box">
                    <p
                        class="eye-close-title"
                        :style="sensesStatus(balanceData.currentData.eyeOpenLevel)"
                    >{{ selectLevelStatus(balanceData.currentData.eyeOpenLevel) }}</p>
                    <p v-if="balanceData.lastData" class="eye-close-title1">
                        <img
                            v-if="
                balanceData.currentData.eyeOpenLevel < balanceData.lastData.eyeOpenLevel
              "
                            src="@/assets/images/icon1_rise.png"
                            alt
                        />
                        <img
                            v-else-if="
                balanceData.currentData.eyeOpenLevel > balanceData.lastData.eyeOpenLevel
              "
                            src="@/assets/images/icon1_decline.png"
                            alt
                        />
                        <img v-else src="@/assets/images/icon1_just.png" alt />
                        {{ this.$t('balanceReport.last') }}：
                        {{ selectLevelStatus(balanceData.lastData.eyeOpenLevel) }}
                    </p>
                </div>
                <div class="eye-close-points">
                    <div class="eye-close-points-div">
                        <span>{{ $t("waist.qian") }}</span>
                        <span>{{ $t("mass.segment.left") }}</span>
                        <span>{{ $t("mass.segment.right") }}</span>
                        <span>{{ $t("waist.hou") }}</span>
                        <div class="circle">
                            <!-- 动态生成随机点 -->
                            <div v-for="(point, index) in pointsOpen" :key="index" class="dot" :style="point.style"></div>
                        </div>
                        <p>{{ $t("balanceReport.centerTrajectory") }}</p>
                    </div>
                    <!-- <div class="eye-close-points-div">
            <p class="eye-close-points-div-h">{{ $t("balanceReport.copArea") }}</p>
            <p class="eye-close-points-div-h1">
              {{
                unit === "metric"
                  ? toDecimal(eyeOpenObj.area * 645.16, 2)
                  : toDecimal(eyeOpenObj.area, 2)
              }}{{ unit === "imperial" ? "in²" : "mm²" }}
            </p>
            <p class="eye-close-points-div-h">{{ $t("balanceReport.avgSpeed") }}</p>
            <p class="eye-close-points-div-h1">
              {{
                unit === "metric"
                  ? toDecimal(eyeOpenObj.speed * 25.4, 2)
                  : toDecimal(eyeOpenObj.speed, 2)
              }}{{ unit === "imperial" ? "in/s" : "mm/s" }}
            </p>
            <p class="eye-close-points-div-h">
              {{ $t("balanceReport.maxDisplacement") }}
            </p>
            <p class="eye-close-points-div-h1">
              {{
                unit === "metric"
                  ? toDecimal(eyeOpenObj.distance * 25.4, 2)
                  : toDecimal(eyeOpenObj.distance, 2)
              }}{{ unit === "imperial" ? "in" : "mm" }}
            </p>
                    </div>-->
                </div>
                <div class="close-table">
                    <table>
                        <thead>
                            <tr>
                                <th>{{ $t("balanceReport.copArea") }}</th>
                                <th>{{ $t("balanceReport.avgSpeed") }}</th>
                                <th>{{ $t("balanceReport.maxDisplacement") }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    {{
                                    unit === "metric"
                                    ? toDecimal(eyeOpenObj.area * 645.16, 2)
                                    : toDecimal(eyeOpenObj.area, 2)
                                    }}{{ unit === "imperial" ? "in²" : "mm²" }}
                                </td>
                                <td>
                                    {{
                                    unit === "metric"
                                    ? toDecimal(eyeOpenObj.speed * 25.4, 2)
                                    : toDecimal(eyeOpenObj.speed, 2)
                                    }}{{ unit === "imperial" ? "in/s" : "mm/s" }}
                                </td>
                                <td>
                                    {{
                                    unit === "metric"
                                    ? toDecimal(eyeOpenObj.distance * 25.4, 2)
                                    : toDecimal(eyeOpenObj.distance, 2)
                                    }}{{ unit === "imperial" ? "in" : "mm" }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="eye-close-points-des">{{ conclusion(balanceData.currentData.eyeOpenLevel, true) }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import DateSelect from '@/components/common/DateSelect'
import * as echarts from 'echarts'
import { getBalanceReportInfo, findBalanceTrueHistory, findBalanceQuotaInfos } from '@/assets/js/apolloGql.js'
import { _toDecimal } from '@/assets/js/util.js'
export default {
    name: 'Index',
    props: {
        isCreateTime: String,
        massInfo: Object,
    },
    components: {
        DateSelect,
    },
    data() {
        return {
            score: '--',
            levelDesc: this.$t('balanceReport.levelDesc'),
            modelInfo: JSON.parse(window.localStorage.getItem('modelInfo')),
            pointsClose: [],
            pointsOpen: [],
            balanceData: {
                currentData: {
                    eyeCloseLevel: 0,
                    eyeOpenLevel: 0,
                },
                lastData: {
                    eyeCloseLevel: 0,
                    eyeOpenLevel: 0,
                },
                totalScoreComparison: 0,
            },
            eyeCloseObj: {
                area: 0,
                speed: 0,
                distance: 0,
                points: [],
                sway_index: 0,
            }, // 闭眼眼平衡
            eyeOpenObj: {
                area: 0,
                speed: 0,
                distance: 0,
                points: [],
                sway_index: 0,
            }, // 睁眼平衡
            unit: window.localStorage.getItem('unit'),
            overStatus: true,
            // 坐标值 第一个闭眼横线
            limit: [3.5, 1.6, 2.0, 0.8],
        }
    },
    computed: {
        status() {
            if (this.score >= 90) return this.$t('balanceReport.status.excellent')
            if (this.score >= 75) return this.$t('balanceReport.status.good')
            if (this.score >= 60) return this.$t('balanceReport.status.medium')
            if (this.score >= 45) return this.$t('balanceReport.status.fair')
            return this.$t('balanceReport.status.poor')
        },
        levelStatus() {
            if (this.score >= 90) return require('@/assets/images/blance/youxiu.png')
            if (this.score >= 75) return require('@/assets/images/blance/lianghao.png')
            if (this.score >= 60) return require('@/assets/images/blance/zhongdeng.png')
            if (this.score >= 45) return require('@/assets/images/blance/yiban.png')
            return require('@/assets/images/blance/bad.png')
        },
        closeYMax() {
            return this.unit === 'metric'
                ? this.limit[0] * 2 - this.limit[1]
                : this.toDecimal((this.limit[0] * 2 - this.limit[1]) / 2.54, 2)
        },
        openEyeYMax() {
            return this.unit === 'metric'
                ? this.limit[2] * 2 - this.limit[3]
                : this.toDecimal((this.limit[2] * 2 - this.limit[3]) / 2.54, 2)
        },
    },
    mounted() {
        this.getBalanceReportInfo()
        //获取历史记录
        this.findBalanceTrueHistory()
    },
    methods: {
        // 获取历史记录
        async findBalanceTrueHistory() {
            this.$apollo
                .query({
                    query: findBalanceTrueHistory,
                    variables: {
                        memberId: this.modelInfo.memberId,
                        scanTime: window.localStorage.getItem('createTime')
                            ? JSON.parse(window.localStorage.getItem('createTime'))
                            : this.modelInfo.createTime,
                        deviceType: JSON.parse(window.localStorage.getItem('deviceType')),
                    },
                    fetchPolicy: 'network-only',
                })
                .then((res) => {
                    const data = res.data.findBalanceTrueHistory
                    let balanceArray = []
                    if (data && data.code === 200) {
                        for (let index = 0; index < data.data.length; index++) {
                            for (let aa = 0; aa < data.data[index].data.length; aa++) {
                                balanceArray.push(data.data[index].data[aa])
                            }
                        }
                    }
                    this.$store.commit('setBalanceArray', balanceArray)
                })
        },

        toDecimal(num, digit) {
            return _toDecimal(num, digit)
        },
        // 公制转英制
        toDecimalIn(num, digit) {
            const nums = this.unit === 'metric' ? num : num / 2.54
            return _toDecimal(nums, digit)
        },
        // 获取对比数据
        onGetBalance(tcScanId) {
            this.$apollo
                .query({
                    query: findBalanceQuotaInfos,
                    variables: {
                        memberId: this.modelInfo.memberId,
                        scanId: this.massInfo.scanId,
                        tcScanId: tcScanId,
                    },
                    fetchPolicy: 'network-only',
                })
                .then((res) => {
                    const info = res.data.findBalanceQuotaInfos
                    if (info.code === 200) {
                        this.balanceData = info.data
                        this.score = this.balanceData.currentTotalScore
                        const closeUnescaped = this.balanceData.currentData.eyeCloseData
                            .replace(/\\r\\n/g, '')
                            .replace(/\\"/g, '"')
                        this.eyeCloseObj = JSON.parse(closeUnescaped)
                        const openUnescaped = this.balanceData.currentData.eyeOpenData
                            .replace(/\\r\\n/g, '')
                            .replace(/\\"/g, '"')
                        this.eyeOpenObj = JSON.parse(openUnescaped)

                        // 绘制平衡折线图
                        this.drawBalanceTest('main-balance', 0)
                        this.drawBalanceTest('main-balance-open', 1)
                        // 画点坐标
                        this.generateRandomDots(this.eyeCloseObj.points, 0)
                        // 画点睁眼坐标
                        this.generateRandomDots(this.eyeOpenObj.points, 1)
                        this.overStatus = false
                    }
                })
        },
        // 获取平衡数据报告
        async getBalanceReportInfo() {
            const userInfo = {
                scanId: this.massInfo.scanId,
                memberId: this.modelInfo.memberId,
            }
            await this.$apollo
                .query({
                    query: getBalanceReportInfo,
                    variables: userInfo,
                    fetchPolicy: 'network-only',
                })
                .then((res) => {
                    const info = res.data.getBalanceReportInfo
                    if (info.code === 200) {
                        this.balanceData = info.data
                        this.score = this.balanceData.currentTotalScore
                        const closeUnescaped = this.balanceData.currentData.eyeCloseData
                            .replace(/\\r\\n/g, '')
                            .replace(/\\"/g, '"')
                        this.eyeCloseObj = JSON.parse(closeUnescaped)
                        const openUnescaped = this.balanceData.currentData.eyeOpenData
                            .replace(/\\r\\n/g, '')
                            .replace(/\\"/g, '"')
                        this.eyeOpenObj = JSON.parse(openUnescaped)

                        // 绘制平衡折线图
                        this.drawBalanceTest('main-balance', 0)
                        this.drawBalanceTest('main-balance-open', 1)
                        // 画点坐标
                        this.generateRandomDots(this.eyeCloseObj.points, 0)
                        // 画点睁眼坐标
                        this.generateRandomDots(this.eyeOpenObj.points, 1)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        // 结论
        conclusion(level, type) {
            // type true 为睁眼
            if (type) {
                switch (level) {
                    case 0:
                        return ''
                    case 1:
                        return this.$t('balanceReport.conclusion.eyeOpen.level1')
                    case 2:
                        return this.$t('balanceReport.conclusion.eyeOpen.level2')
                    case 3:
                        return this.$t('balanceReport.conclusion.eyeOpen.level3')
                    default:
                        return this.$t('balanceReport.conclusion.eyeOpen.level4')
                }
            } else {
                switch (level) {
                    case 0:
                        return ''
                    case 1:
                        return this.$t('balanceReport.conclusion.eyeClose.level1')
                    case 2:
                        return this.$t('balanceReport.conclusion.eyeClose.level2')
                    case 3:
                        return this.$t('balanceReport.conclusion.eyeClose.level3')
                    default:
                        return this.$t('balanceReport.conclusion.eyeClose.level4')
                }
            }
        },
        trajectoryPoints(pointsData) {
            let maxDistance = 0
            pointsData.forEach((point) => {
                // 计算点到原点的距离: √(x² + y²)
                const distance = Math.sqrt(Math.abs(point.x) ** 2 + Math.abs(point.y) ** 2)
                maxDistance = Math.max(maxDistance, distance)
            })
            return maxDistance
        },
        // 得到点
        generateRandomDots(pointsData, type) {
            if (type === 1) {
                const proportion = 40 / this.trajectoryPoints(pointsData)
                this.pointsOpen = pointsData.map((p) => ({
                    style: {
                        transform: `translate(-50%, -50%) translate(${p.x * proportion}px, ${-p.y * proportion}px)`,
                    },
                }))
            } else {
                const proportion = 40 / this.trajectoryPoints(pointsData)
                this.pointsClose = pointsData.map((p) => ({
                    style: {
                        transform: `translate(-50%, -50%) translate(${p.x * proportion}px, ${-p.y * proportion}px)`,
                    },
                }))
            }
        },
        // 感官系统评分等级
        sensesStatus(level) {
            if (level === 1) return { color: '#4CAF50' }
            if (level === 2) return { color: '#009FE8' }
            if (level === 3) return { color: '#E56016' }
            return { color: '#C32613' }
        },
        selectColor() {
            const score = this.score
            if (score >= 90) {
                return '#4CAF50'
            } else if (score >= 75) {
                return '#009FE8'
            } else if (score >= 60) {
                return '#E6B12A'
            } else if (score >= 45) {
                return '#E56016'
            } else if (score < 45) {
                return '#C32613'
            }
        },
        selectColorComparison(data) {
            if (data > 0) {
                return '#29d590'
            } else if (data < 0) {
                return '#DB942C'
            } else {
                return '#8aa3be'
            }
        },
        // 级别
        selectLevelStatus(status) {
            switch (status) {
                case 0:
                    return ''
                case 1:
                    return this.$t('balanceReport.levelStatus.A')
                case 2:
                    return this.$t('balanceReport.levelStatus.B')
                case 3:
                    return this.$t('balanceReport.levelStatus.C')
                default:
                    return this.$t('balanceReport.levelStatus.D')
            }
        },
        // 平衡数据点
        drawBalanceTest(box, type) {
            const chartDom = document.getElementById(box)
            if (!chartDom) return console.error('容器不存在！')
            const myChart = echarts.init(chartDom)
            const isRtl = this.$i18n.locale === 'ar-AR'
            const pointsData = this.toDecimal(
                this.unit === 'metric'
                    ? (type ? this.eyeOpenObj.sway_index : this.eyeCloseObj.sway_index) * 2.54
                    : type
                    ? this.eyeOpenObj.sway_index
                    : this.eyeCloseObj.sway_index,
                2
            )
            // 绘制图表
            myChart.setOption({
                title: {
                    // text: '晃动程度（RMS）',
                    textStyle: {
                        color: '#666666', // 标题颜色（蓝色）
                        fontSize: 14,
                        fontWeight: 'normal',
                    },
                },
                tooltip: { show: false },
                grid: {
                    left: this.$i18n.locale === 'en-US' || this.$i18n.locale === 'fi-FI' ? 86 : isRtl ? 32 : 52,
                    bottom: 16,
                    top: 30,
                    right: isRtl ? 52 : 32,
                    containLabel: true,
                }, // 移动原点
                xAxis: {
                    data: [
                        type ? this.$t('balanceReport.chart.eyeOpenTest') : this.$t('balanceReport.chart.eyeCloseTest'),
                    ],
                    inverse: isRtl, // 反转x轴方向
                    // axisLine: { show: true, lineStyle: { color: '#009FE8' }}, // X轴线颜色
                    axisLabel: {
                        color: '#8AA3BE',
                        fontSize: 12,
                        // lineHeight: 20
                        // formatter: function (value) {
                        //   const words = value.split(" ");
                        //   let lines = [];
                        //   let currentLine = "";

                        //   words.forEach((word) => {
                        //     // 判断当前行长度 + 新单词长度，超过 8 个字符就换行
                        //     if ((currentLine + word).length > 16) {
                        //       if (currentLine) lines.push(currentLine); // 推入当前行
                        //       currentLine = word + " ";
                        //     } else {
                        //       currentLine += word + " ";
                        //     }
                        //   });
                        //   if (currentLine) lines.push(currentLine.trim());

                        //   return lines.join("\n"); // 用换行符连接
                        // },
                    }, // X轴文字颜色
                    axisTick: { show: false },
                    axisLine: {
                        lineStyle: { color: '#8AA3BE' },
                        symbol: isRtl ? ['arrow', 'none'] : ['none', 'arrow'], // 末端箭头
                        symbolSize: [4, 10], // 宽度，高度
                        symbolOffset: isRtl ? [-8, 0] : [0, 0],
                    },
                },
                yAxis: [
                    {
                        type: 'value', // 主 Y 轴，用于 scatter
                        min: 0,
                        max: type ? this.openEyeYMax : this.closeYMax,
                        splitNumber: 3,
                        // position: 'right',
                        axisLine: {
                            lineStyle: { color: '#8AA3BE' },
                            symbol: ['none', 'arrow'],
                            symbolSize: [4, 10],
                        },
                        axisTick: { show: false },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: '#8AA3BE', // 👈 横线颜色
                                width: 1, // 线宽
                                type: 'solid', // 线类型 solid / dashed / dotted
                            },
                        }, // 隐藏分割线
                        axisLabel: { show: false }, // 主轴不显示文字
                    },
                    {
                        type: 'category', // 辅助 Y 轴，用于显示低/中/高
                        // data: this.$t("balanceReport.chart.yAxisLabels"),
                        // inverse: true,
                        position: isRtl ? 'right' : 'left',
                        axisLine: {
                            lineStyle: { color: '#8AA3BE' },
                            symbol: ['none', 'arrow'],
                            symbolSize: [4, 10],
                        },
                        axisTick: { show: false },
                        axisLabel: {
                            formatter: '{value}',
                            color: '#8AA3BE',
                            rich: { high: { verticalAlign: 'top' } },
                            fontSize: 12,
                        },
                    },
                ],
                series: [
                    {
                        name: '晃动值',
                        type: 'scatter',
                        data: (() => {
                            //  this.openEyeYMax
                            // // 如果测量值超过Y轴最大值，则显示位置限制在最大值
                            const displayValue =
                                pointsData <= (type ? this.openEyeYMax : this.closeYMax)
                                    ? pointsData
                                    : type
                                    ? this.openEyeYMax
                                    : this.closeYMax
                            return [displayValue] // [x, y]格式
                        })(),
                        yAxisIndex: 0,
                        symbolSize: 8,
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                                { offset: 0, color: '#00E3C9' },
                                { offset: 1, color: '#009FE8' },
                            ]), // 散点颜色（红色）
                        },
                        label: {
                            show: true, // 显示数值
                            position: 'top', // 在点的上方
                            color: '', // 数值文字颜色
                            fontSize: 14,
                            formatter: function () {
                                return pointsData // 显示数据值
                            },
                        },
                        // markLine: {
                        //     data: [[{ yAxis: 0.68 }, { yAxis: 0.68 }]],
                        //     lineStyle: { color: '#fff', width: 2 }
                        // }
                    },
                ],
            })
        },
    },
}
</script>
<style lang="less" scoped>
.balance-box {
    margin-top: 20px;
    padding: 0 12px;
    .over-box {
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background: rgba(45, 44, 44, 0.9);
        z-index: 999;
        margin: auto;
        .van-loading {
            top: 50%;
        }
    }
    .compare-report {
        border-radius: 6px;
        color: #cfd8ef;
        position: relative;
        background-image: url('../../assets/images/blance/image-back.png');
        background-size: 100% 100%;
        // height: 73px;
        .compare-title {
            font-size: 14px;
            color: #8aa3be;
            font-style: normal;
            padding-top: 7px;
            width: 150px;
            text-align: center;
            margin: 0 auto;
        }
    }
    .eclairs-v {
        margin-top: 16px;
        min-height: 644px;
        margin-bottom: 26px;
        background-image: url('../../assets/images/blance/backGround.png');
        background-size: 100% 100%;
        overflow-y: hidden;
        .last-style {
            margin-top: 4px;
            font-size: 12px;
            color: #8aa3be;
            line-height: 12px;
            text-align: center;
            font-style: normal;
            img {
                width: 14px;
                height: 14px;
                position: relative;
                top: 4px;
            }
        }
        .eclairs-v-tittle {
            font-weight: 500;
            font-size: 36px;
            line-height: 36px;
            text-align: center;
            margin-top: 16px;
            color: #009fe8;
            span {
                font-size: 12px;
                line-height: 12px;
            }
            position: relative;
            &::after {
                content: '';
                position: absolute;
                background-image: url('../../assets/images/blance/line2x.png');
                background-size: contain;
                background-repeat: no-repeat;
                width: 71px;
                height: 4px;
                top: 18px;
                left: 43px;
                background-position: right;
            }
            &::before {
                content: '';
                content: '';
                position: absolute;
                background-image: url('../../assets/images/blance/line2x.png');
                background-size: contain;
                background-repeat: no-repeat;
                width: 71px;
                height: 4px;
                top: 18px;
                right: 43px;
                transform: scaleX(-1);
                background-position: right;
            }
        }
        .eclairs-v-score {
            margin-top: 10px;
            margin-bottom: 32px;
            color: #009fe8;
            line-height: 25px;
            text-align: center;
            img {
                width: 18px;
                height: 18px;
                position: relative;
                top: 4px;
            }
        }
        .eclairs-v-des {
            width: 323px;
            height: 95px;
            background: rgba(255, 255, 255, 0.04);
            margin: 0 auto;
            border-radius: 2px;
            position: relative;
            .eclairs-v-des-title {
                display: flex;
                justify-content: space-between;

                div {
                    width: 50%;
                    text-align: center;
                    padding-top: 16px;
                    &:first-child {
                        &::after {
                            content: '';
                            width: 1px;
                            height: 40px;
                            border: 1px solid #5b7189;
                            position: relative;
                            top: -26px;
                            right: -49.6%;
                        }
                    }
                }
                p {
                    font-size: 12px;
                    color: #8aa3be;
                    line-height: 17px;
                    text-align: center;
                    font-style: normal;
                }
                span {
                    display: block;
                    text-align: center;
                    font-size: 12px;
                    color: #4caf50;
                    line-height: 12px;
                    font-style: normal;
                    margin-top: 8px;
                }
            }
            .eclairs-v-des-bottom {
                font-size: 12px;
                color: rgba(138, 163, 190, 0.6);
                background: rgba(255, 255, 255, 0.04);
                line-height: 22px;
                text-align: left;
                font-style: normal;
                padding-left: 7px;
                padding-top: 2px;
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                img {
                    width: 12px;
                    height: 12px;
                    position: relative;
                    top: 2px;
                    margin-right: 4px;
                }
            }
        }
        .eclairs-line {
            p {
                margin: 32px 17px 0px 24px;
                font-size: 14px;
                color: #ffffff;
                line-height: 17px;
                text-align: left;
                font-style: normal;
                position: relative;
                &::after {
                    content: '';
                    width: 2px;
                    height: 12px;
                    background: linear-gradient(90deg, #00e3c9 0%, #009fe8 100%);
                    position: absolute;
                    left: -10px;
                    top: 2px;
                }
            }
            .main-balance-box,
            .main-balance-box1 {
                position: relative;
                li {
                    list-style: none;
                    color: #8aa3be;
                    font-size: 12px;
                    line-height: 17px;
                }
                .main-balance-s1 {
                    display: inline-block;
                    position: absolute;
                    top: 66px;
                    font-size: 12px;
                    color: #8aa3be;
                    right: 48px;
                }
                .main-balance-s2 {
                    display: inline-block;
                    position: absolute;
                    top: 102px;
                    font-size: 12px;
                    color: #8aa3be;
                    right: 48px;
                }
                .balance-li-1 {
                    position: absolute;
                    top: 25px;
                    left: 54px;
                }
                .balance-li-2 {
                    position: absolute;
                    top: 50px;
                    left: 34px;
                }
                .balance-li-3 {
                    position: absolute;
                    top: 84px;
                    left: 34px;
                }
                .balance-li-4 {
                    position: absolute;
                    top: 116px;
                    left: 34px;
                }
            }
            .main-balance-box1 {
                .main-balance-s3 {
                    display: inline-block;
                    position: absolute;
                    top: 68px;
                    font-size: 12px;
                    color: #8aa3be;
                    right: 48px;
                }
                .main-balance-s4 {
                    display: inline-block;
                    position: absolute;
                    top: 105px;
                    font-size: 12px;
                    color: #8aa3be;
                    right: 48px;
                }
                .balance-li-1 {
                    top: 20px;
                    left: 54px;
                }
                .balance-li-2 {
                    top: 54px;
                }
                .balance-li-3 {
                    top: 86px;
                }
                .balance-li-4 {
                    top: 116px;
                }
            }
            #main-balance,
            #main-balance-open {
                position: relative;
                top: 16px;
                margin-bottom: 26px;
                left: 0;
                right: 0;
                margin: 0 auto;
                background: rgba(255, 255, 255, 0.04);
                width: 323px;
                height: 175px;
                &::before {
                    content: '';
                    position: absolute;
                    width: 253px;
                    height: 1px;
                    bottom: 69px;
                    left: 52px;
                    background: #5b7189;
                    z-index: 0;
                }
                &::after {
                    content: '';
                    position: absolute;
                    width: 253px;
                    height: 1px;
                    bottom: 109px;
                    left: 52px;
                    background: #5b7189;
                    z-index: 0;
                }
            }
            #main-balance-open {
                margin-top: 16px;
                &::before {
                    bottom: 64px;
                }
                &::after {
                    bottom: 106px;
                }
            }
        }
    }
    .measure-obvious {
        font-weight: bold;
        font-size: 16px;
        color: #ffffff;
        line-height: 20px;
        text-align: center;
        font-style: normal;
        margin: 32px 0 16px 0;
        position: relative;
        &::after {
            content: '';
            position: absolute;
            background-image: url('../../assets/images/blance/line2x.png');
            background-size: contain;
            background-repeat: no-repeat;
            background-position: right;
            width: 116px;
            height: 4px;
            top: 8px;
            left: 0px;
        }
        &::before {
            content: '';
            content: '';
            position: absolute;
            background-image: url('../../assets/images/blance/line2x.png');
            background-size: contain;
            background-repeat: no-repeat;
            background-position: right;
            width: 116px;
            height: 4px;
            top: 8px;
            right: 0px;
            transform: scaleX(-1);
        }
    }
    .measure-obvious-points {
        background-image: url('../../assets/images/blance/pointsBackground.png');
        background-size: 100% 100%;
        min-height: 400px;
        margin-bottom: 16px;
        overflow: hidden;
        .measure-obvious-points-p,
        .measure-obvious-points-pp {
            margin: 12px 0 0 26px;
            //   font-weight: bold;
            font-size: 14px;
            color: #ffffff;
            line-height: 20px;
            text-align: left;
            font-style: normal;
            // font-family: PingFangSC-Regular, PingFang SC;
            position: relative;
            &::after {
                content: '';
                position: absolute;
                left: -8px;
                top: 4px;
                width: 2px;
                height: 12px;
                background: linear-gradient(90deg, #00e3c9 0%, #009fe8 100%);
            }
        }
        .measure-obvious-points-pp {
            margin-top: 32px;
        }
        .eye-close-box {
            margin-top: 24px;
            .eye-close-title {
                position: relative;
                font-size: 18px;
                color: #4caf50;
                font-weight: bold;
                line-height: 25px;
                text-align: center;
                &::after {
                    content: '';
                    width: 48px;
                    height: 1px;
                    position: absolute;
                    background: linear-gradient(90deg, rgba(76, 175, 80, 0), rgba(138, 163, 190, 1));
                    top: 12px;
                    left: 93px;
                }
                &::before {
                    content: '';
                    width: 48px;
                    height: 1px;
                    position: absolute;
                    background: linear-gradient(90deg, rgba(138, 163, 190, 1), rgba(138, 163, 190, 0));
                    top: 12px;
                    right: 93px;
                }
            }
            .eye-close-title1 {
                font-size: 12px;
                color: #8aa3be;
                line-height: 17px;
                text-align: center;
                font-style: normal;
                img {
                    width: 14px;
                    height: 14px;
                    position: relative;
                    top: 2px;
                    margin-right: 4px;
                }
            }
        }
        .eye-close-points {
            width: 323px;
            height: 227px;
            background: rgba(255, 255, 255, 0.04);
            margin: 32px auto 0;
            .eye-close-points-div {
                position: relative;
                span {
                    color: #86909c;
                    font-size: 12px;
                    display: inline-block;
                    position: absolute;
                    line-height: 12px;
                    &:nth-child(1) {
                        top: 20px;
                        left: 0;
                        right: 0;
                        margin: auto;
                    }
                    &:nth-child(2) {
                        top: 90px;
                        left: 86px;
                    }
                    &:nth-child(3) {
                        top: 90px;
                        right: 86px;
                    }
                    &:nth-child(4) {
                        top: 162px;
                        left: 0;
                        right: 0;
                        margin: auto;
                    }
                }
                p {
                    margin-top: 32px;
                    font-size: 12px;
                    color: #8aa3be;
                    line-height: 17px;
                    text-align: center;
                    font-style: normal;
                }

                .circle {
                    margin-top: 41px;
                    position: relative;
                    width: 112px;
                    height: 112px;
                    border-radius: 50%; /* 圆形 */
                    border: 1px solid #5b7189; /* 蓝色边框 */
                    display: inline-block;
                    text-align: right;
                }

                /* 水平十字线 */
                .circle::before {
                    content: '';
                    position: absolute;
                    top: 50%;
                    left: 0;
                    width: 100%;
                    height: 1px;
                    background-color: #5b7189; /* 蓝色线 */
                    transform: translateY(-50%);
                    z-index: 0;
                }

                /* 垂直十字线 */
                .circle::after {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 50%;
                    width: 1px;
                    height: 100%;
                    background-color: #5b7189; /* 蓝色线 */
                    transform: translateX(-50%);
                    z-index: 0;
                }

                .dot {
                    position: absolute;
                    width: 2px;
                    height: 2px;
                    border-radius: 50%; /* 圆点 */
                    background-color: #ec6060; /* 红色点 */
                    /* 初始定位到容器中心 */
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%); /* 中心点校准 */
                    z-index: 999;
                }
                .eye-close-points-div-h {
                    margin-top: 0px;
                    font-size: 12px;
                    color: #8aa3be;
                    line-height: 17px;
                    text-align: left;
                    font-style: normal;
                }
                .eye-close-points-div-h1 {
                    margin-top: 4px;
                    font-size: 12px;
                    color: #ffffff;
                    line-height: 17px;
                    text-align: left;
                    font-style: normal;
                    margin-bottom: 16px;
                }
            }
        }
        .close-table {
            // width: 100%;
            margin-top: 24px;
            table {
                width: 93%;
                margin: 0 auto;
                border-collapse: collapse;
                // font-family: PingFangSC-Regular, PingFang SC;
                thead {
                    background: rgba(255, 255, 255, 0.04);
                    tr {
                        height: 25px;
                    }
                    th {
                        width: 33.3%;
                        font-size: 12px;
                        color: #8aa3be;
                        line-height: 14px;
                        text-align: center;
                        border: none;
                    }
                }
                tbody {
                    // border: 1px solid #ced7e0;
                    width: 323px;
                    height: 33px;
                    background: rgba(255, 255, 255, 0.02);
                    td {
                        font-size: 12px;
                        height: 33px;
                        color: #ffffff;
                        line-height: 18px;
                        text-align: center;
                        font-style: normal;
                    }
                }
            }
        }
        .measure-obvious-points-br {
            height: 1px;
            background: #8aa3be;
            opacity: 0.32;
            margin: 0 14px;
        }
        .eye-close-points-des {
            background: rgba(255, 255, 255, 0.08);
            border-radius: 2px;
            margin: 24px 14px 24px 14px;
            font-weight: 400;
            font-size: 12px;
            color: #8aa3be;
            line-height: 17px;
            text-align: left;
            font-style: normal;
            padding: 12px;
        }
    }
}
.en-US,
.fi-FI,
.pl-PL {
    #main-balance,
    #main-balance-open {
        &::before {
            width: 220px !important;
            left: 87px !important;
        }
        &::after {
            width: 220px !important;
            left: 87px !important;
        }
    }
    .main-balance-box,
    .main-balance-box1 {
        .balance-li-2,
        .balance-li-3,
        .balance-li-4 {
            left: 28px !important;
        }
        .balance-li-1 {
            left: 83px !important;
        }
    }
    .measure-obvious {
        &::after {
            left: -38px !important;
        }
        &::before {
            right: -38px !important;
        }
    }
    .eye-close-points-div {
        span {
            &:nth-child(2) {
                left: 80px !important;
            }
            &:nth-child(3) {
                right: 70px !important;
            }
        }
    }
    .close-table {
        table {
            thead {
                th {
                    padding: 6px 0 !important;
                }
            }
        }
    }
}
.fi-FI {
    .main-balance-box1,
    .main-balance-box {
        .balance-li-2,
        .balance-li-3,
        .balance-li-4 {
            left: 17px !important;
        }
    }
    .eye-close-points-div {
        span {
            &:nth-child(2) {
                left: 70px !important;
            }
            &:nth-child(3) {
                right: 70px !important;
            }
        }
    }
}
.pl-PL {
    #main-balance,
    #main-balance-open {
        &::before {
            left: 52px !important;
            width: 245px !important;
        }
        &::after {
            left: 52px !important;
            width: 245px !important;
        }
    }
    /* 闭眼图与睁眼图共用一套刻度：与 .main-balance-box1 默认偏移对齐，避免「Średni」等与 Y 轴重叠 */
    #main-balance {
        &::before {
            bottom: 64px !important;
        }
        &::after {
            bottom: 106px !important;
        }
    }
    .main-balance-box {
        .balance-li-1 {
            top: 20px !important;
        }
        .balance-li-2 {
            top: 56px !important;
        }
        .balance-li-3 {
            top: 88px !important;
        }
        .balance-li-4 {
            top: 116px !important;
        }
        .main-balance-s1 {
            top: 68px !important;
        }
        .main-balance-s2 {
            top: 105px !important;
        }
    }
    .main-balance-box,
    .main-balance-box1 {
        .balance-li-1 {
            left: 50px !important;
        }
        .balance-li-2,
        .balance-li-3,
        .balance-li-4 {
            left: -25px !important;
            width: 68px;
            text-align: right;
            font-size: 11px !important;
        }
    }
    .eye-close-points-div {
        span {
            &:nth-child(2) {
                left: 72.5px !important;
            }
        }
    }
}
.ar-AR {
    .eclairs-v {
        .eclairs-v-des {
            .eclairs-v-des-title {
                div {
                    &:first-child {
                        &::after {
                            left: -49.6%;
                            right: auto;
                        }
                    }
                }
            }
            .eclairs-v-des-bottom {
                text-align: right;
                padding-left: 0;
                padding-right: 7px;
                img {
                    margin-left: 4px;
                    margin-right: 0;
                }
            }
        }
        .eclairs-line {
            p {
                margin: 32px 24px 0px 17px;
                text-align: right;
                &::after {
                    left: auto;
                    right: -10px;
                }
            }
            .main-balance-box,
            .main-balance-box1 {
                .balance-li-1 {
                    left: auto;
                    right: 50px;
                }
                .balance-li-2 {
                    left: auto;
                    right: 34px;
                }
                .balance-li-3 {
                    left: auto;
                    right: 30px;
                }
                .balance-li-4 {
                    left: auto;
                    right: 26px;
                }
                .main-balance-s1 {
                    left: 48px;
                    right: auto;
                }
                .main-balance-s2 {
                    left: 48px;
                    right: auto;
                }
                .main-balance-s3 {
                    left: 48px;
                    right: auto;
                }
                .main-balance-s4 {
                    left: 48px;
                    right: auto;
                }
            }
            #main-balance,
            #main-balance-open {
                &::before {
                    left: auto;
                    right: 52px;
                }
                &::after {
                    left: auto;
                    right: 52px;
                }
            }
        }
    }
    .measure-obvious {
        &::after {
            left: -40px;
        }
        &::before {
            right: -40px;
        }
    }
    .measure-obvious-points {
        .measure-obvious-points-p,
        .measure-obvious-points-pp {
            margin: 12px 26px 0 0;
            text-align: right;
            &::after {
                left: auto;
                right: -8px;
            }
        }
        .eye-close-box {
            .eye-close-title1 {
                img {
                    margin-left: 4px;
                    margin-right: auto;
                }
            }
        }
        .eye-close-points-des {
            text-align: right;
        }
    }
}
.el-GR {
    .compare-report {
        .compare-title {
            width: 130px;
        }
    }
    .eclairs-v {
        .eclairs-line {
            .main-balance-box,
            .main-balance-box1 {
                .balance-li-1 {
                    left: 50px;
                }
                .balance-li-2 {
                    left: 24px;
                }
                .balance-li-3 {
                    left: 24px;
                }
                .balance-li-4 {
                    left: 19px;
                }
            }
        }
    }
    .measure-obvious {
        margin: 32px auto 16px;
        width: 300px;
        &::after {
            left: -80px;
        }
        &::before {
            right: -80px;
        }
    }
    .measure-obvious-points .eye-close-points {
        .eye-close-points-div {
            span {
                &:nth-child(2) {
                    left: 50px;
                }
                &:nth-child(3) {
                    right: 70px;
                }
            }
        }
    }
}
</style>
